export const ENABLE_DESTINATION_WIZARD_TYPE = "enable-destination";
